import React from "react";
import Immutable from "immutable";
import moment from "moment";
import * as TargetsAPI from "js/oneview/targets/targets-api";
import * as Users from "js/common/users";
import {formatDateTime} from "js/common/utils/time";

const targetSource = "ClickThrough";

const getDefaultNote = note => Immutable.fromJS({
  automatedNote: false,
  createdDate: formatDateTime(moment()),
  userId: Users.getCurrentUser().get("id"),
  note
});

export const useTargetNotes = (targets, setTargets, viewType) => {
  const [selectedTargetId, setSelectedTargetId] = React.useState(null);
  const [isAddingNote, setIsAddingNote] = React.useState(false);
  const [addNoteError, setAddNoteError] = React.useState(null);

  const selectTarget = React.useCallback((targetId) => {
    setSelectedTargetId(targetId);
    setAddNoteError(null);
  }, []);

  const deselectTarget = React.useCallback(() => {
    setSelectedTargetId(null);
    setAddNoteError(null);
  }, []);

  const addNote = React.useCallback((targetId, note) => {
    if (viewType === "EDIT") {
      setTargets(currentTargets => {
        const targetIndex = currentTargets.findIndex(t => t.get("id") === targetId);
        const newNote = getDefaultNote(note);
        return currentTargets.updateIn([targetIndex, "noteAssignmentDtos"], notes => notes.push(newNote));
      });
      return Promise.resolve();
    } else {
      setIsAddingNote(true);
      setAddNoteError(null);

      return TargetsAPI
          .addTargetNote(targetId, note, targetSource)
          .then(targetNote => {
            setTargets(currentTargets => {
              const targetIndex = currentTargets.findIndex(t => t.get("id") === targetId);
              return currentTargets.updateIn([targetIndex, "noteAssignmentDtos"], notes => notes.push(targetNote));
            });
          })
          .catch(() => {
            setAddNoteError("Unable to add note");
          })
          .finally(() => {
            setIsAddingNote(false);
          });
    }
  }, [viewType, setTargets]);

  return {
    selectedTargetId,
    isAddingNote,
    addNoteError,
    selectTarget,
    deselectTarget,
    addNote
  };
};